<div class="graphic-option-card" [class.graphic-option-card--selected]="selected()" (click)="onCardClick()">
  <div class="graphic-option-card-header">
    @if (mode() === 'radio') {
      <mat-radio-button [value]="value()" (click)="$event.stopPropagation()">
        <span class="graphic-option-card-title">{{ title() }}</span>
      </mat-radio-button>
    } @else {
      <mat-checkbox [checked]="selected()" (click)="$event.stopPropagation()" (change)="selectionChange.emit()">
        <span class="graphic-option-card-title">{{ title() }}</span>
      </mat-checkbox>
    }
  </div>
  <mat-icon class="graphic-option-card-icon">{{ icon() }}</mat-icon>
  <p class="graphic-option-card-description">{{ description() }}</p>
</div>
